import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.search";
import "regenerator-runtime/runtime";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import { localizeDate } from '../../utils/vuex';
import { get } from 'lodash';
import { templateMixin } from '../../components/core/templateMixin';
import { versionsHasUnsyncedChanges } from '../../utils/deviceTemplateUtils';
export default {
  name: 'DeviceTemplatesList',
  mixins: [templateMixin],
  data: function data() {
    return {
      selectedAccounts: [],
      accountFilterIsReady: false,
      cacheBuster: 0,
      itemIdToBeDeleted: null,
      showDialogCreate: false,
      page: 1,
      itemsPerPage: 10,
      totalCountOfLinkedDevices: 0,
      linkedDevices: [],
      isLoading: false,
      itemToDelete: null,
      devicesHasNextPage: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    isDeviceTemplateManager: function isDeviceTemplateManager() {
      return this.permissions['DeviceTemplate.manage'];
    },
    tableHeaders: function tableHeaders() {
      var _this = this;

      var headers = [{
        text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.tableHeaders.id'),
        value: 'id',
        sortable: true
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.tableHeaders.title'),
        value: 'title',
        isTitle: true,
        sortable: true
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.tableHeaders.deviceDriverId'),
        value: 'deviceDriverInfo',
        sortable: true
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.tableHeaders.account'),
        value: 'Tenant.name',
        sortable: true
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.tableHeaders.status'),
        value: 'deviceSyncStatus',
        isTemplateStatus: true,
        sortable: false
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.tableHeaders.createdAt'),
        value: 'createdAt',
        sortable: true
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.tableHeaders.updatedAt'),
        value: 'updatedAt',
        sortable: true
      }, {
        align: 'end',
        sortable: false,
        value: 'actions'
      }];

      if (this.isDeviceTemplateManager) {
        headers.push({
          text: this.$i18n_t('DeviceDriver.list.table.headers.actions'),
          isButtons: true,
          align: 'center',
          sortable: false,
          buttons: [{
            icon: 'fal fa-edit',
            color: this.color,
            onClick: function onClick(item) {
              _this.$router.push(_this.getSingleTemplateUrl(item.id));
            }
          }, {
            icon: 'fal fa-trash-alt',
            color: this.color,
            onClick: function onClick(item) {
              _this.itemToDelete = item;
              _this.devicesHasNextPage = true;

              _this.fetchLinkedVirtualDevices(item);

              _this.onDeleteClick(item);
            }
          }]
        });
      }

      return headers;
    },
    deletePromptTitle: function deletePromptTitle() {
      if (this.totalCountOfLinkedDevices > 0) {
        return this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.linkedVirtualDevicesTitle', {
          count: this.totalCountOfLinkedDevices
        });
      } else {
        return this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.deleteDialog.title');
      }
    },
    deletePromptDescription: function deletePromptDescription() {
      if (this.totalCountOfLinkedDevices > 0) {
        return this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.linkedVirtualDevicesDescription');
      } else {
        return this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.deleteDialog.message');
      }
    }
  }),
  methods: {
    get: get,
    localizeDate: localizeDate,
    finishedCreating: function finishedCreating() {
      this.showDialogCreate = false;
    },
    getSingleTemplateUrl: function getSingleTemplateUrl(id) {
      return "/device-templates/".concat(id, "?tab=tab-device-meta");
    },
    fetchItems: function () {
      var _fetchItems = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
        var _this2 = this;

        var search, page, perPage, sortBy, sortDirection, selectedAccounts, tenantIds, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                search = options.search, page = options.page, perPage = options.perPage, sortBy = options.sortBy, sortDirection = options.sortDirection, selectedAccounts = options.selectedAccounts;
                tenantIds = selectedAccounts.map(function (account) {
                  return account.id;
                });
                _context.prev = 2;
                _context.next = 5;
                return ApiService.deviceTemplatesFetch({
                  page: page,
                  pageSize: perPage,
                  sortBy: sortBy,
                  sortDesc: sortDirection === 'desc',
                  search: search,
                  tenantIds: tenantIds
                });

              case 5:
                result = _context.sent;
                return _context.abrupt("return", {
                  items: result.data.map(function (item) {
                    var accountName = item.DraftVersion.tenantId;

                    if (item.DraftVersion.account && item.DraftVersion.account.name) {
                      accountName = item.DraftVersion.account.name;
                    }

                    return _objectSpread(_objectSpread({}, item.DraftVersion), {}, {
                      account: _objectSpread(_objectSpread({}, item.DraftVersion.account), {}, {
                        name: accountName
                      }),
                      createdAt: _this2.localizeDate(item.DraftVersion.createdAt),
                      updatedAt: _this2.localizeDate(item.DraftVersion.updatedAt),
                      hasUnsyncedChanges: versionsHasUnsyncedChanges(item),
                      deviceDriverInfo: "".concat(item.DraftVersion.devicedriver.title, " (").concat(item.DraftVersion.deviceDriverVersion, ")")
                    });
                  }),
                  total: result.pagination['total-count']
                });

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);
                console.error(_context.t0);
                this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.snacks.fetchError'), 'error');

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 9]]);
      }));

      function fetchItems(_x) {
        return _fetchItems.apply(this, arguments);
      }

      return fetchItems;
    }(),
    onDeleteClick: function onDeleteClick(item) {
      this.itemIdToBeDeleted = item.id;
    },
    onDeleteItemConfirm: function () {
      var _onDeleteItemConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var itemId;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                itemId = this.itemIdToBeDeleted;
                _context2.prev = 1;
                _context2.next = 4;
                return ApiService.deviceTemplateDelete(itemId);

              case 4:
                this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.snacks.deleteSuccess'), 'success');
                this.cacheBuster += 1;
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                console.error(_context2.t0);
                this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.snacks.deleteError'), 'error');

              case 12:
                _context2.prev = 12;
                this.itemIdToBeDeleted = null;
                return _context2.finish(12);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 8, 12, 15]]);
      }));

      function onDeleteItemConfirm() {
        return _onDeleteItemConfirm.apply(this, arguments);
      }

      return onDeleteItemConfirm;
    }(),
    fetchLinkedVirtualDevices: function () {
      var _fetchLinkedVirtualDevices = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(item) {
        var _this$linkedDevices;

        var data, linkedDevices;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.isLoading || !this.devicesHasNextPage)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                this.isLoading = true;
                data = {
                  id: item.id,
                  pageSize: this.itemsPerPage,
                  page: this.page,
                  tenantId: item.tenantId
                };
                _context3.next = 6;
                return ApiService.fetchLinkedVirtualDevices(data);

              case 6:
                linkedDevices = _context3.sent;
                this.totalCountOfLinkedDevices = linkedDevices.pagination['total-count'];

                (_this$linkedDevices = this.linkedDevices).push.apply(_this$linkedDevices, _toConsumableArray(linkedDevices.data));

                if (this.linkedDevices.length >= linkedDevices.pagination['total-count']) {
                  this.devicesHasNextPage = false;
                }

                this.isLoading = false;

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchLinkedVirtualDevices(_x2) {
        return _fetchLinkedVirtualDevices.apply(this, arguments);
      }

      return fetchLinkedVirtualDevices;
    }(),
    handleScroll: function handleScroll() {
      var scrollContainer = this.$refs.scrollContainer;

      if (scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight) {
        this.page += 1;
        this.fetchLinkedVirtualDevices(this.itemToDelete);
      }
    }
  }
};